import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const salespersonApi = createApi({
  reducerPath: 'salespersonApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Salesperson'],
  endpoints: (builder) => ({

    getSalespersons: builder.query({
      query: () => '/salespersons',
      providesTags: [{ type: 'Salesperson', id: 'LIST' }],
    }),

  }),
});

export const {
  useGetSalespersonsQuery,
  useLazyGetSalespersonsQuery,
} = salespersonApi;
